if (!customElements.get('glow-ugc-videos')) {
  customElements.define(
    'glow-ugc-videos',
    class GlowUgcVideos extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-glow-ugc-play]').forEach((button) => {
          button.addEventListener('click', () => this.play(button.closest('.glow-ugc__card')));
        });
        this.querySelectorAll('.glow-ugc__video').forEach((video) => {
          video.addEventListener('pause', () => video.closest('.glow-ugc__card').classList.remove('is-playing'));
          video.addEventListener('ended', () => video.closest('.glow-ugc__card').classList.remove('is-playing'));
        });
      }

      play(card) {
        const video = card && card.querySelector('.glow-ugc__video');
        if (!video) return;
        document.querySelectorAll('.glow-ugc__video').forEach((other) => {
          if (other !== video && !other.paused) other.pause();
        });
        video.controls = true;
        card.classList.add('is-playing');
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => card.classList.remove('is-playing'));
        video.focus({ preventScroll: true });
      }
    }
  );
}
